import { render, staticRenderFns } from "./getApi.vue?vue&type=template&id=a97002ae&scoped=true"
import script from "./getApi.vue?vue&type=script&lang=js"
export * from "./getApi.vue?vue&type=script&lang=js"
import style0 from "./getApi.vue?vue&type=style&index=0&id=a97002ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97002ae",
  null
  
)

export default component.exports